/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 0
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VehicleHighlightContextFromJSON, VehicleHighlightContextToJSON, } from './VehicleHighlightContext';
/**
 * @export
 */
export const VehicleHighlightKeyEnum = {
    AccelerationHigh: 'AccelerationHigh',
    AccelerationVeryHigh: 'AccelerationVeryHigh',
    BatteryRangeHigh: 'BatteryRangeHigh',
    BatteryRangeVeryHigh: 'BatteryRangeVeryHigh',
    BootSpaceLarge: 'BootSpaceLarge',
    BootSpaceVeryLarge: 'BootSpaceVeryLarge',
    CargoVolumeLarge: 'CargoVolumeLarge',
    CargoVolumeVeryLarge: 'CargoVolumeVeryLarge',
    Co2EmissionLow: 'Co2EmissionLow',
    Co2EmissionVeryLow: 'Co2EmissionVeryLow',
    DemandHigh: 'DemandHigh',
    DemandVeryHigh: 'DemandVeryHigh',
    EnginePowerHigh: 'EnginePowerHigh',
    EnginePowerVeryHigh: 'EnginePowerVeryHigh',
    FeaturesHasRare: 'FeaturesHasRare',
    FeaturesHasValuable: 'FeaturesHasValuable',
    FeaturesHasVeryRare: 'FeaturesHasVeryRare',
    FuelEconomyHigh: 'FuelEconomyHigh',
    FuelEconomyVeryHigh: 'FuelEconomyVeryHigh',
    InsuranceGroupLow: 'InsuranceGroupLow',
    InsuranceGroupVeryLow: 'InsuranceGroupVeryLow',
    MileageLow: 'MileageLow',
    MileageVeryLow: 'MileageVeryLow',
    NumberOwnersLow: 'NumberOwnersLow',
    NumberOwnersOnePrevious: 'NumberOwnersOnePrevious',
    NumberOwnersVeryLow: 'NumberOwnersVeryLow',
    PayloadWeightLarge: 'PayloadWeightLarge',
    PayloadWeightVeryLarge: 'PayloadWeightVeryLarge'
};
/**
 * @export
 */
export const VehicleHighlightQuantifierEnum = {
    High: 'HIGH',
    VeryHigh: 'VERY_HIGH',
    Large: 'LARGE',
    VeryLarge: 'VERY_LARGE',
    Low: 'LOW',
    VeryLow: 'VERY_LOW',
    HasRare: 'HAS_RARE',
    HasValuable: 'HAS_VALUABLE',
    HasVeryRare: 'HAS_VERY_RARE',
    OnePrevious: 'ONE_PREVIOUS'
};
/**
 * Check if a given object implements the VehicleHighlight interface.
 */
export function instanceOfVehicleHighlight(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('vehicleHighlightContext' in value) || value['vehicleHighlightContext'] === undefined)
        return false;
    return true;
}
export function VehicleHighlightFromJSON(json) {
    return VehicleHighlightFromJSONTyped(json, false);
}
export function VehicleHighlightFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'badge': json['badge'] == null ? undefined : json['badge'],
        'linkDescription': json['linkDescription'] == null ? undefined : json['linkDescription'],
        'quantifier': json['quantifier'] == null ? undefined : json['quantifier'],
        'vehicleHighlightContext': VehicleHighlightContextFromJSON(json['vehicleHighlightContext']),
    };
}
export function VehicleHighlightToJSON(json) {
    return VehicleHighlightToJSONTyped(json, false);
}
export function VehicleHighlightToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'title': value['title'],
        'description': value['description'],
        'badge': value['badge'],
        'linkDescription': value['linkDescription'],
        'quantifier': value['quantifier'],
        'vehicleHighlightContext': VehicleHighlightContextToJSON(value['vehicleHighlightContext']),
    };
}
